import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as react from "react";
import { FileButtonLine } from "shared-ui-components/lines/fileButtonLineComponent.js";
import { NumericInput } from "shared-ui-components/lines/numericInputComponent.js";
import { Tools } from "core/Misc/tools.js";
import { OptionsLine } from "shared-ui-components/lines/optionsLineComponent.js";
import { CheckBoxLineComponent } from "../../../sharedComponents/checkBoxLineComponent.js";
import { GetTextureInputBlockEditorData } from "../../../graphSystem/getEditorData.js";
import { LazyTextInputLineComponent } from "../../../sharedComponents/lazyTextInputLineComponent.js";
import { Debounce } from "../../../helpers/debounce.js";
const CustomImageOption = -1;
const AssetTypeOptionArray = ["image", "video"];
const AssetTypeOptions = AssetTypeOptionArray.map((value, index) => {
    return { label: value, value: index };
});
const DataUrlPlaceholder = "";
/**
 * The UI for editing the properties of a texture input block.
 */
export class ImageSourcePropertyTabComponent extends react.Component {
    // eslint-disable-next-line babylonjs/available
    constructor(props) {
        super(props);
        this._imageOptions = [{ label: "Custom", value: CustomImageOption }];
        this._texturePresets = props.stateManager.data.texturePresets;
        let index = 0;
        this._texturePresets.forEach((preset) => {
            this._imageOptions.push({
                label: preset.name,
                value: index++,
            });
        });
        this._imageOptions;
    }
    // eslint-disable-next-line babylonjs/available
    render() {
        const editorData = GetTextureInputBlockEditorData(this.props.inputBlock);
        // If the reloadAssets callback wasn't supplied, don't show any properties
        if (!this.props.stateManager.data.reloadAssets) {
            return null;
        }
        // Don't read/write the url directly, it may be base64 encoded data and not a URL
        // In that case, we show a placeholder instead
        const urlTextInputTarget = {
            url: (editorData.url ?? "").indexOf("data:") === 0 ? DataUrlPlaceholder : editorData.url,
        };
        return (_jsxs("div", { children: [_jsx(OptionsLine, { label: "Source", target: {}, propertyName: "value", options: this._imageOptions, noDirectUpdate: true, extractValue: () => {
                        if (editorData.url?.startsWith("data:")) {
                            return CustomImageOption;
                        }
                        const url = editorData.url || this.props.inputBlock.runtimeValue.value?.getInternalTexture()?.url;
                        if (!url) {
                            return CustomImageOption;
                        }
                        const texturePresetIndex = this._imageOptions.findIndex((c) => (this._texturePresets[c.value]?.url || "") === url);
                        return texturePresetIndex !== -1 ? this._imageOptions[texturePresetIndex].value : CustomImageOption;
                    }, onSelect: (newSelectionValue) => {
                        if (newSelectionValue === CustomImageOption || typeof newSelectionValue === "string") {
                            // Take no action, let the user click the Upload button
                            return;
                        }
                        editorData.url = this._texturePresets[newSelectionValue]?.url || "";
                        editorData.urlTypeHint = this._getUrlTypeHint(editorData.url);
                        this._triggerAssetUpdate(true);
                    } }), _jsx(FileButtonLine, { label: "Upload Custom Image", onClick: (file) => {
                        Tools.ReadFile(file, (data) => {
                            const blob = new Blob([data], { type: "octet/stream" });
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onloadend = () => {
                                const base64data = reader.result;
                                let extension = null;
                                if (file.name.toLowerCase().indexOf(".dds") > 0) {
                                    extension = ".dds";
                                }
                                else if (file.name.toLowerCase().indexOf(".env") > 0) {
                                    extension = ".env";
                                }
                                editorData.url = base64data;
                                editorData.forcedExtension = extension;
                                editorData.urlTypeHint = this._getUrlTypeHint(file.name);
                                this.forceUpdate();
                                this._triggerAssetUpdate(true);
                            };
                        }, undefined, true);
                    }, accept: ".jpg, .jpeg, .png, .tga, .dds, .env" }), _jsx(OptionsLine, { label: "Asset Type", target: {}, propertyName: "value", options: AssetTypeOptions, noDirectUpdate: true, extractValue: () => {
                        const value = editorData.urlTypeHint ?? "image";
                        return AssetTypeOptionArray.indexOf(value);
                    }, onSelect: (newSelectionValue) => {
                        if (typeof newSelectionValue === "number") {
                            editorData.urlTypeHint = AssetTypeOptionArray[newSelectionValue];
                            this._triggerAssetUpdate(true);
                        }
                    } }), _jsx(LazyTextInputLineComponent, { label: "URL", propertyName: "url", lockObject: this.props.stateManager.lockObject, target: urlTextInputTarget, onSubmit: () => {
                        if (urlTextInputTarget.url !== DataUrlPlaceholder) {
                            editorData.url = urlTextInputTarget.url;
                            editorData.urlTypeHint = this._getUrlTypeHint(editorData.url ?? "");
                            this._triggerAssetUpdate();
                        }
                    } }, this.props.inputBlock.uniqueId), _jsx(CheckBoxLineComponent, { label: "FlipY", target: editorData, propertyName: "flipY", onValueChanged: () => this._triggerAssetUpdate(true) }), _jsx(NumericInput, { lockObject: this.props.stateManager.data.lockObject, label: "AFL", labelTooltip: "anisotropicFilteringLevel", precision: 0, value: editorData.anisotropicFilteringLevel ?? 4, onChange: (value) => {
                        editorData.anisotropicFilteringLevel = value;
                        this._triggerAssetUpdate(true);
                    } })] }));
    }
    _triggerAssetUpdate(instant = false) {
        this.props.stateManager.onUpdateRequiredObservable.notifyObservers(this.props.inputBlock);
        this.forceUpdate();
        const update = () => {
            const globalState = this.props.stateManager.data;
            globalState.reloadAssets?.();
        };
        if (instant) {
            update();
        }
        else {
            Debounce(update, 1000)();
        }
    }
    _getUrlTypeHint(url) {
        const extension = url.toLowerCase().split(".").pop() ?? null;
        return extension === "mp4" ? "video" : "image";
    }
}
//# sourceMappingURL=imageSourcePropertyTabComponent.js.map